export default __webpack_public_path__ + "static/media/three.cdd5656a.svg";